export default __webpack_public_path__ + "static/media/headset.c527945d.svg";